// "Conectar com a Lezty Pay" (`spec/32-oauth-connect.md` §6, WEB-140). Rota FORA do shell
// `/app`, no visual do login. Aceita `client_id` + `request_uri` (entrada vinda do LeztyBot)
// ou `resume=1` (volta do Didit). `client_id` é lido e ignorado: só existe um client.

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthorizeScreen } from '../features/oauth/authorize-screen.tsx';

const searchSchema = z.object({
  client_id: z.string().optional(),
  request_uri: z.string().optional(),
  // `?resume=1` chega como número; `true` é o que o `navigate` do SPA monta.
  resume: z
    .union([z.literal(1), z.literal('1'), z.literal(true)])
    .optional()
    .catch(undefined),
});

function Authorize() {
  const { request_uri, resume } = Route.useSearch();
  return <AuthorizeScreen requestUri={request_uri} resume={resume !== undefined} />;
}

export const Route = createFileRoute('/oauth/authorize')({
  validateSearch: searchSchema,
  component: Authorize,
});
